<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p>{{text}}</p>
  <mat-form-field class="full-width" *ngIf="companies.length > 0">
    <mat-select placeholder="Company" [(ngModel)]="company" (ngModelChange)="companyChanged()" required>
      <mat-option *ngFor="let company of companies" [value]="company">{{ company.name }}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field class="full-width">
    <mat-select placeholder="Product" [(ngModel)]="product" required>
      <mat-option *ngFor="let product of products" [value]="product">{{product.internalName}}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field class="full-width">
    <mat-select placeholder="Card Type" [(ngModel)]="cardType" required>
      <mat-option value="1">Virtual</mat-option>
      <!--<mat-option value="2">Physical</mat-option>-->
      <!--<mat-option value="3">Initially Virtual</mat-option>
      <mat-option value="4">MVC</mat-option>-->
      <mat-option value="900">Pseudo-Card</mat-option>
    </mat-select>
  </mat-form-field>
  <div class="checkbox-form-field">
    <mat-checkbox name="virtualOnly" [(ngModel)]="virtualOnly">Virtual-Only card</mat-checkbox>
  </div>
  <mat-form-field class="full-width">
    <input matInput placeholder="Comment" [(ngModel)]="comment">
  </mat-form-field>
</div>

<div *ngIf="product">
  {{product.id}}<br />
  {{ product.internalName }}
  {{ product.companyName }} - {{ product.name }}
</div>

<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="onNoClick()" cdkFocusInitial color="primary">Cancel</button>
  <button mat-raised-button (click)="onYesClick()" color="accent" [disabled]="product == null">Confirm</button>
</div>
